<web-design-system-button [type]="type" [size]="size" [disabled]="disabled" [fullwidth]="fullwidth">
  <div class="d-flex gap-half justify-content-center align-items-center inner">
    @if (icon) {
      <web-design-system-icon class="icon" [name]="icon" />
    }
    <ng-content />
  </div>
</web-design-system-button>
